import * as React from 'react';
import { noop } from 'lodash';

export type AppStateFormData = {
  packageType: string;
};

type AppStateContext = {
  isCompleted: boolean;
  formData: AppStateFormData;
  updateFormData: (value: AppStateFormData) => void;
  setScrollPosition: (position?: number) => void;
  updateSetScrollPosition: (callback: (position: number) => void) => void;
};

const Context = React.createContext<AppStateContext>({
  isCompleted: false,
  formData: { packageType: '' },
  updateFormData: noop,
  setScrollPosition: noop,
  updateSetScrollPosition: noop
});
export const useAppStateContext = () => React.useContext(Context);

export const AppStateProvider: React.FC = ({ children }) => {
  const [formData, setFormData] = React.useState<AppStateFormData>({ packageType: '' });
  const resetScrollPositionCallbackRef = React.useRef<(position: number) => void>(() => {});
  const isCompleted = !!formData;

  const updateFormData = (value: AppStateFormData) => {
    setFormData(value);
  };

  const updateSetScrollPosition = (callback: (position: number) => void) => {
    resetScrollPositionCallbackRef.current = callback;
  };

  return (
    <Context.Provider
      value={{
        isCompleted,
        formData,
        updateFormData,
        setScrollPosition: (position: number = 0) => resetScrollPositionCallbackRef.current(position),
        updateSetScrollPosition
      }}
    >
      {children}
    </Context.Provider>
  );
};
